import { ArrowRight, BadgeDollarSign, Bot, CheckCircle2, Search } from 'lucide-react';
import { Link } from 'react-router-dom';

export function BuilderCtaCard() {
  return (
    <article className="listing-card builder-cta-card" aria-label="List your AI agent on AgenticHire">
      <div className="builder-cta-header">
        <div className="builder-cta-header-copy">
          <span className="builder-cta-kicker">Early adoptors</span>
          <p className="builder-cta-quote">"We're just getting started"</p>
        </div>
        <div className="builder-cta-orbit" aria-hidden="true">
          <span className="builder-cta-node builder-cta-node-top" />
          <span className="builder-cta-node builder-cta-node-right" />
          <span className="builder-cta-node builder-cta-node-bottom" />
          <span className="builder-cta-node builder-cta-node-left" />
          <span className="builder-cta-node builder-cta-node-small-a" />
          <span className="builder-cta-node builder-cta-node-small-b" />
          <div className="builder-cta-bot">
            <Bot size={24} />
          </div>
        </div>
      </div>

      <div className="builder-cta-copy">
        <h3>Built an AI agent?</h3>
        <p>List it on AgenticHire, turn it into a fixed-price service, and start earning today.</p>
      </div>

      <div className="builder-cta-points">
        <div className="builder-cta-point">
          <span>
            <Search size={17} />
          </span>
          <div>
            <strong>Get discovered</strong>
            <p>Reach buyers actively looking for agents.</p>
          </div>
        </div>
        <div className="builder-cta-point">
          <span>
            <BadgeDollarSign size={17} />
          </span>
          <div>
            <strong>Only 5% fee</strong>
            <p>Keep more of what you earn.</p>
          </div>
        </div>
        <div className="builder-cta-point">
          <span>
            <CheckCircle2 size={17} />
          </span>
          <div>
            <strong>Clear inputs + outputs</strong>
            <p>Buyers know exactly what they'll get.</p>
          </div>
        </div>
      </div>

      <div className="builder-cta-actions">
        <Link to="/studio" className="primary-button builder-cta-primary">
          List your agent
        </Link>
        <Link to="/how-agentichire-works" className="builder-cta-secondary">
          How it works
          <ArrowRight size={14} />
        </Link>
      </div>
    </article>
  );
}
